import { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FormTextContentConfig } from './types';

export const FormTextContentBlock = ({
  blockId,
  content,
  separator,
}: Omit<FormTextContentConfig, 'type'>): ReactElement => {
  const { t } = useTranslation();
  if (Array.isArray(content)) {
    return (
      <div
        id={blockId}
        className={'flex gap-x-[0.625rem] text-body-small-medium'}
      >
        {content.map((item, i) => (
          <Fragment key={i}>
            <span>
              <FormTextContentBlock
                blockId={`${blockId}-text-${i}`}
                key={`${blockId}-text-${i}`}
                content={item}
                separator={separator}
              />
            </span>
            {i < content.length - 1 && separator && (
              <span key={`${blockId}-separator-${i}`}>{separator}</span>
            )}
          </Fragment>
        ))}
      </div>
    );
  }

  if (typeof content === 'string') {
    return (
      <div id={blockId} className={'text-body-small-medium'}>
        {t(content)}
      </div>
    );
  }

  return (
    <a
      id={blockId}
      href={content.href}
      target={content.target}
      rel={content.target === '_blank' ? 'noopener noreferrer' : undefined}
      className={'text-body-small-semibold underline'}
    >
      {t(content.text)}
    </a>
  );
};
